/**
 * This returns the document title
 * @param orgName
 * @param teamName
 * @param title
 * @returns {string}
 */
export default ({ orgName, teamName, title } = {}) => {
  const items = [orgName, teamName, title].filter(Boolean)
  return items.join(' › ')
}
